import { FileText } from "lucide-react";
import { CollapsibleCard } from "../CollapsibleCard";
import { storageTypesMap, rackAccessoriesMap } from "../../constants";
import { renderBadgeList } from "../../utils";

interface StorageConfigurationSectionProps {
  submission: any;
  defaultOpen?: boolean;
}

export const StorageConfigurationSection = ({
  submission,
  defaultOpen = false,
}: StorageConfigurationSectionProps) => {
  return (
    <CollapsibleCard title="4. Storage Configuration" defaultOpen={defaultOpen}>
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex flex-col gap-1 md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Storage Types
            </span>
            {renderBadgeList(
              submission.storageTypes as string[],
              storageTypesMap
            )}
            {submission.otherStorageTypeDetails && (
              <p className="text-sm text-muted-foreground mt-1">
                Other: {submission.otherStorageTypeDetails}
              </p>
            )}
          </div>

          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Pallet Dimensions (L x W x H)
            </span>
            <span className="text-sm font-medium">
              {submission.palletDimensions || "—"}
            </span>
          </div>

          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Oversized Loads
            </span>
            <span className="text-sm font-medium">
              {submission.hasOversizedLoads ? "Yes" : "No"}
            </span>
          </div>
          {submission.hasOversizedLoads && submission.oversizedLoadsDetails && (
            <div className="flex flex-col gap-1 md:space-y-1 md:mt-2">
              <span className="text-sm font-medium text-muted-foreground">
                Details
              </span>
              <span className="text-sm font-medium">
                {submission.oversizedLoadsDetails}
              </span>
            </div>
          )}

          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Pallet Material
            </span>
            <span className="text-sm font-medium">
              {submission.palletMaterial}
            </span>
          </div>

          <div className="flex flex-col gap-1 md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Rack Accessories
            </span>
            {renderBadgeList(
              submission.rackAccessories as string[] | undefined,
              rackAccessoriesMap
            )}
          </div>

          {/* Floor Plan & Elevations */}
          {submission.files?.floorPlanElevations &&
            submission.files.floorPlanElevations.length > 0 && (
              <div className="space-y-2 pt-3 border-t md:border-t-0 md:pt-0 md:col-span-2">
                <span className="text-sm font-medium text-muted-foreground">
                  Floor Plan & Elevations
                </span>
                <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:gap-4">
                  {submission.files.floorPlanElevations.map(
                    (file: any, index: number) => (
                      <a
                        key={index}
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-sm font-medium text-primary hover:underline"
                      >
                        <FileText className="mr-2 h-4 w-4" />
                        {file.name}
                      </a>
                    )
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </CollapsibleCard>
  );
};
